import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  EntryForm,
  Column,
  TinyEditor,
} from "../components/EntryForm";
import Page from "../components/Page";
import { useUserProvider } from "../providers/UserProvider";
import { GetApp, UpdateApp } from "../services/api/app";

const FreeAccountMessage = () => {
  const [initialValues, setInitialValues] = useState({});
  const { user, setUser } = useUserProvider();
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory();
  useEffect(() => {
    const { enterprise_free_account_message } = user?.app_data?.setup ?? {};
    setInitialValues({
      enterprise_free_account_message: enterprise_free_account_message,
    });
  }, [user]);

  let links = [
    { name: "Home", url: "/" },
    { name: "Free Account Message", url: `/free_account_message` },
  ];

  let schema = {
    enterprise_free_account_message: Yup.string().required("Required"),
  };

  const getData = useCallback(() => {
    GetApp(user, user.idToken)
      .then((res) => res.json())
      .then((res) => {
        let tempUser = user;
        tempUser.app_data.setup = res.data.setup;
        setUser(tempUser);

        history.push('/')
   
      }).finally(() => {
        setIsLoading(false)
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape(schema),
    onSubmit: async (values) => {
      setIsLoading(true)
      const payload = { setup: values };
      UpdateApp(user.currentApp(), user.idToken, { data: payload }).then(() => getData())
    },
  });

  return (
    <Page links={links} title={"Free Account Message"} isLoading={isLoading}>
      <EntryForm
        formik={formik}
        submitHandler={formik.handleSubmit}
        cancelURL="/"
      >
        <Column>
          <TinyEditor
            name="enterprise_free_account_message"
            quillName="web_text"
            type="text"
            label={"Free Account Message"}
            formik={formik}
          />
        </Column>
      </EntryForm>
    </Page>
  );
};

export default FreeAccountMessage;
